import { PageLoader } from '~/components/page/PageLoader';

export default function ModernBackgroundRoute() {
  return <PageLoader pageName="modern-background" showTitle={false} />;
}
